import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const feesApi = createApi({
    reducerPath: 'feesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '/api/webapi/selling/commissionfee',
    }),
    endpoints: (builder) => ({
        // itemType and price does not affect the provision fee,
        // therefore we defaults to itemType `Auction` and price `1`
        getCommissionFee: builder.query({
            query: ({ categoryId }) =>
                `?categoryId=${categoryId}&itemType=Auction&price=1`,
        }),
    }),
});

export const { useGetCommissionFeeQuery } = feesApi;
